import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@src/components/ui/tooltip";
import { cn } from "@src/lib/utils";
import styles from "./CodeChip.module.less";

interface CodeChipProps {
  codeType: string;
  code: string;
  description: string | null;
  role: string;
}

const CODE_TYPE_LABEL: Record<string, string> = {
  icd10: "ICD-10",
  hcc: "HCC",
};

export const CodeChip = ({
  codeType,
  code,
  description,
  role,
}: CodeChipProps) => {
  const typeLabel = CODE_TYPE_LABEL[codeType] ?? codeType.toUpperCase();
  const roleClass =
    role === "use_additional"
      ? styles["chip--use_additional"]
      : role === "manifestation"
        ? styles["chip--manifestation"]
        : undefined;

  const ariaLabel = `${typeLabel} code ${code}${
    description ? `, ${description}` : ""
  }`;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn(styles.chip, roleClass)} aria-label={ariaLabel}>
            <span className={styles.type}>{typeLabel}</span>
            <span className={styles.code}>{code}</span>
          </span>
        </TooltipTrigger>
        <TooltipContent>
          {description ? <div>{description}</div> : null}
          <div>Role: {role}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
